module.exports = __webpack_public_path__ + "img/LogoSlothysBakery.0e5d6872.png";